import Avatar from '../Avatar';

/**
 * Overlapping voter avatars for lineup schedule blocks and group list rows.
 */
export default function VoterAvatarStack({
  people = [],
  max = 5,
  size = 22,
  overlap = -7,
  /** The first face on top and the rest tucked behind it (the Sets rows, Sam 2026-10-23); default: each on top of the last. */
  firstOnTop = false,
  /** false where a count already says how many (the Sets votes pill). */
  showOverflow = true,
  className = '',
}) {
  if (people.length === 0) return null;

  const shown = people.slice(0, max);
  const overflow = people.length - max;
  const overflowFontSize = Math.max(8, Math.round(size * 0.4));

  return (
    <div className={`voter-avatar-stack ${className}`.trim()} aria-hidden>
      {shown.map((person, i) => (
        <div
          key={person.id}
          className="voter-avatar-stack__avatar"
          style={{
            zIndex: firstOnTop ? shown.length - i : i + 1,
            width: size,
            height: size,
            marginLeft: i > 0 ? overlap : 0,
          }}
        >
          <Avatar
            displayName={person.display_name}
            profilePhotoUrl={person.profile_photo_url}
            size="xxs"
            className="!h-full !w-full"
          />
        </div>
      ))}
      {showOverflow && overflow > 0 && (
        <div
          className="voter-avatar-stack__overflow"
          style={{
            zIndex: firstOnTop ? 0 : shown.length + 1,
            width: size,
            height: size,
            marginLeft: overlap,
            fontSize: overflowFontSize,
          }}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
}
